import { NavigateFunction } from 'react-router-dom';
import { NavigateLink } from '@/components/navigate/NavigateLinks';

export const agendaPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [{ label: 'Inicio', onClick: () => navigate('/') }];

export const childrenAttendTrackPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...agendaPageBreadcrumbs(navigate),
  { label: 'Monitoreo de agendas', onClick: () => navigate('/attend-track') },
];

